import Store from '@/store'

export class HeroKindStoreUtils {

    static fetchHeroKinds() {
        return Store.dispatch("hero-kind-store/fetchHeroKinds");
    }

    static createHeroKind(data) {
        console.log("HeroKindStoreUtils createHeroKind");
        console.log(data);
        return Store.dispatch("hero-kind-store/createHeroKind", data);
    }

    static deleteHeroKind(key) {
        return Store.dispatch("hero-kind-store/deleteHeroKind", key);
    }

    //GETTERS
    static getHeroKinds() {
        return Store.getters["hero-kind-store/getHeroKinds"];
    }
}